import api from "./api";
import TokenService from "./token.service";
class AuthService {
  login(username, password) {
    return api
      .post("/auth/signin", {
        username,
        password
      })
      .then(response => {        
        if (response.data.jwtToken) {
          TokenService.setUser(response.data);
        }
        return response.data;
      });
  }
  logout() {
    return api.post("/auth/signout").then(
      response => {
        TokenService.removeUser();
        TokenService.removeUserRoles();
        window.location.reload();
      }).catch((error) => {
        TokenService.removeUser();
        window.location.reload();
        TokenService.removeUserRoles();
      });
  }

  register(firstName, lastName, email, password, countryId) {
    return api.post("/auth/signup", {
      firstName,
      lastName,
      email,
      password,
      countryId
    });
  }

  getLoggedInUser() {
    return TokenService.getUser();
  }  

  getUserRoles() {
    return TokenService.getUserRoles();
  }

  ignoreLinks = ['/login', '/register', '/forgot-password', '/privacy-policy', '/contact-us/account-delete' ]

  shouldRedirectToLogin() {
    const currentUser = this.getLoggedInUser();
    return (currentUser === null && !this.ignoreLinks.includes(window.location.pathname) && !window.location.pathname.includes('/set-password/'));
  }

  shouldShowNavBars() {
    const currentUser = this.getLoggedInUser();
    return (currentUser !== null && !this.ignoreLinks.includes(window.location.pathname) && !window.location.pathname.includes('/set-password/'));
  }

}
export default new AuthService();